import {
    SpecialGeometryType,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-interaction.interface';

export function isMarkerAvailableLine(shapeType, specialGeometryType?) {
    return specialGeometryType !== SpecialGeometryType.trendLine && (shapeType === 'line' || shapeType === 'smooth');
}
